import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }

import axios from "axios";
import {computed, ref, nextTick} from "vue";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {__} from "~/ts/library/Translate";
import {AnimationConfigWithData} from "lottie-web";


import {defineAsyncComponent, defineComponent, reactive} from 'vue';
import Dictionary from "~/ts/library/Dictionary";

let stickerCache = reactive<Dictionary<any>>({});

const __default__ = defineComponent({
    name: "AnimatedTelegramSticker",
    components: {
        LottiePlayer: defineAsyncComponent(() => import(/* webpackChunkName: "lottie" */"~/core-ui/vue/ui/LottiePlayer.vue"))
    }
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    url: {},
    width: {},
    height: {}
  },
  emits: ["height-change"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let isLoading = ref(false);
let isError = ref(false);

let sticker = computed<any>(() => {
    if (!stickerCache[props.url]) {
        stickerCache[props.url] = null;
    }
    return stickerCache[props.url];
})

if (!sticker.value) {
    downloadSticker(props.url);
}

async function downloadSticker(url: string) {
    isLoading.value = true;
    try {
        let result = await axios.get(url, {
            responseType: 'arraybuffer'
        });
        if (result.status === 200) {
            let pako = require('pako');
            let pakoResult = JSON.parse(pako.ungzip(result.data, {
                to: 'string'
            }));
            if (pakoResult) {
                stickerCache[props.url] = pakoResult;
                nextTick(() => {
                    emits("height-change");
                });
            }
        } else {
            isError.value = true;
        }
    } catch (e) {
        console.error(e);
        isError.value = true;
    }
    isLoading.value = false;
}



return (_ctx: any,_cache: any) => {
  const _component_lottie_player = _resolveComponent("lottie-player")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(MyLoader, { key: 0 }))
      : (_unref(isError))
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createVNode(FontAwesomeIcon, {
              icon: "frown",
              class: "mr-1"
            }),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Не удалось загрузить стикер')), 1)
          ]))
        : (_unref(sticker))
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(_component_lottie_player, {
                options: {
                    animationData: _unref(sticker)
                } as AnimationConfigWithData,
                width: 180,
                height: 180
              }, null, 8, ["options"])
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})